const DATABASE_NAME = 'json-tool-settings';
const STORE_NAME = 'handles';
const DIRECTORY_KEY = 'library-directory';

export class HandleStore {
  constructor(indexedDb = globalThis.indexedDB) {
    this.indexedDb = indexedDb;
  }

  async getDirectory() {
    if (!this.indexedDb) return null;
    return this.#request('readonly', (store) => store.get(DIRECTORY_KEY));
  }

  async setDirectory(handle) {
    if (!this.indexedDb) throw new Error('当前环境不支持 IndexedDB。');
    await this.#request('readwrite', (store) => store.put(handle, DIRECTORY_KEY));
  }

  async #request(mode, action) {
    const database = await this.#open();
    return new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, mode);
      const request = action(transaction.objectStore(STORE_NAME));
      request.onsuccess = () => resolve(request.result ?? null);
      request.onerror = () => reject(request.error);
      transaction.oncomplete = () => database.close();
      transaction.onerror = () => reject(transaction.error);
    });
  }

  #open() {
    return new Promise((resolve, reject) => {
      const request = this.indexedDb.open(DATABASE_NAME, 1);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(STORE_NAME)) {
          request.result.createObjectStore(STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
}
